import Vue from 'vue'
import Vuex from 'vuex'
import policy from './module/policy'
import certificate from './module/certificate'

Vue.use(Vuex);


const store = new Vuex.Store({
    modules:{
        policy,certificate
    }
    // state:{
    //     payMoney:"100起",
    //     applicantInfoList:[{
    //         personnelType:'1',
    //         name:'',
    //         certificateType:'01',
    //         certificateNo:'',
    //         mobile:''
    //     }]
    // },
    // getters:{
    //     policyIdType: state => {
    //         if (state.applicantInfoList[0].certificateType === '01'){
    //             return '身份证'
    //         } else {
    //             return '统一社会信用代码'
    //         }
    //     },
    //     policyName: state => {
    //         if (state.applicantInfoList[0].certificateType === '01'){
    //             return '姓名'
    //         } else {
    //             return '企业名称'
    //         }
    //     },
    // },
    // mutations:{
    //     setMoney(state,money){
    //         state.payMoney = money;
    //     },
    //     setPersonType(state,type){
    //         if (state.applicantInfoList[0].personnelType !== type){
    //             state.applicantInfoList[0].personnelType = type;
    //             if (type === '1'){
    //                 //个人
    //                 state.applicantInfoList[0].certificateType = '01';
    //             }else {
    //                 //团体
    //                 state.applicantInfoList[0].certificateType = '03';
    //             }
    //         }
    //     }
    // }
});

export default store